import { render, staticRenderFns } from "./BraceletAssignModal.vue?vue&type=template&id=99a352e6&scoped=true"
import script from "./BraceletAssignModal.vue?vue&type=script&lang=js"
export * from "./BraceletAssignModal.vue?vue&type=script&lang=js"
import style0 from "./BraceletAssignModal.vue?vue&type=style&index=0&id=99a352e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a352e6",
  null
  
)

export default component.exports